export function convertEnumToArray(e: any): string[] {
  return Object.values(e);
}
